import { call, put, takeEvery } from "redux-saga/effects";
import {
  CREATE_WORKFLOW_DESIGN_REQUEST,
  GET_WORKFLOW_DESIGN_TICKET_REQUEST,
  LIST_WORKFLOW_DESIGN_TICKETS_REQUEST,
  UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST,
  DELETE_WORKFLOW_DESIGN_TICKET_REQUEST,
  CHECK_WORKFLOW_DESIGN_STATUS_REQUEST,
  // Import the action creators
  createWorkflowDesignSuccess,
  createWorkflowDesignFailure,
  getWorkflowDesignTicketSuccess,
  getWorkflowDesignTicketFailure,
  listWorkflowDesignTicketsSuccess,
  listWorkflowDesignTicketsFailure,
  updateWorkflowDesignTicketSuccess,
  updateWorkflowDesignTicketFailure,
  deleteWorkflowDesignTicketSuccess,
  deleteWorkflowDesignTicketFailure,
  checkWorkflowDesignStatusSuccess,
  checkWorkflowDesignStatusFailure,
} from "../actions/workflowDesignSubmissionActions";
import {
  createWorkflowDesignInApi,
  getWorkflowDesignTicketFromApi,
  listWorkflowDesignTicketsFromApi,
  checkWorkflowDesignStatusFromApi,
} from "../apis/workflowDesignSubmissionApi";

// Create Workflow Design Saga
function* createWorkflowDesignSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - createWorkflowDesignSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(createWorkflowDesignInApi, action.payload);

    if (response.success) {
      yield put(createWorkflowDesignSuccess(response.ticket));
    } else {
      yield put(
        createWorkflowDesignFailure(
          response.error || "Failed to create workflow design"
        )
      );
    }
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - createWorkflowDesignSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      createWorkflowDesignFailure(
        error.message || "Failed to create workflow design"
      )
    );
  }
}

// Get Workflow Design Ticket Saga
function* getWorkflowDesignTicketSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - getWorkflowDesignTicketSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(getWorkflowDesignTicketFromApi, action.payload);
    yield put(getWorkflowDesignTicketSuccess(response));
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - getWorkflowDesignTicketSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      getWorkflowDesignTicketFailure(
        error.message || "Failed to get workflow design ticket"
      )
    );
  }
}

// List Workflow Design Tickets Saga
function* listWorkflowDesignTicketsSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - listWorkflowDesignTicketsSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(
      listWorkflowDesignTicketsFromApi,
      action.payload
    );
    yield put(listWorkflowDesignTicketsSuccess(response));
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - listWorkflowDesignTicketsSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      listWorkflowDesignTicketsFailure(
        error.message || "Failed to list workflow design tickets"
      )
    );
  }
}

// Update Workflow Design Ticket Saga
function* updateWorkflowDesignTicketSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - updateWorkflowDesignTicketSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    // Note: Update functionality would need to be implemented in the API
    // For now, we'll simulate a successful update
    yield put(updateWorkflowDesignTicketSuccess(action.payload));
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - updateWorkflowDesignTicketSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      updateWorkflowDesignTicketFailure(
        error.message || "Failed to update workflow design ticket"
      )
    );
  }
}

// Delete Workflow Design Ticket Saga
function* deleteWorkflowDesignTicketSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - deleteWorkflowDesignTicketSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    // Note: Delete functionality would need to be implemented in the API
    // For now, we'll simulate a successful deletion
    yield put(
      deleteWorkflowDesignTicketSuccess({
        ticketId: action.payload.ticketId,
        message: "Workflow design ticket deleted successfully",
      })
    );
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - deleteWorkflowDesignTicketSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      deleteWorkflowDesignTicketFailure(
        error.message || "Failed to delete workflow design ticket"
      )
    );
  }
}

// Check Workflow Design Status Saga
function* checkWorkflowDesignStatusSaga(action) {
  try {
    console.log(
      `Workflow Design Submission Saga - checkWorkflowDesignStatusSaga - payload: ${JSON.stringify(
        action.payload
      )}`
    );

    const response = yield call(
      checkWorkflowDesignStatusFromApi,
      action.payload.executionArn
    );
    yield put(checkWorkflowDesignStatusSuccess(response));
  } catch (error) {
    console.error(
      `Workflow Design Submission Saga - checkWorkflowDesignStatusSaga - error: ${JSON.stringify(
        error
      )}`
    );
    yield put(
      checkWorkflowDesignStatusFailure(
        error.message || "Failed to check workflow design status"
      )
    );
  }
}

// Root Saga
export function* workflowDesignSubmissionSaga() {
  yield takeEvery(CREATE_WORKFLOW_DESIGN_REQUEST, createWorkflowDesignSaga);
  yield takeEvery(
    GET_WORKFLOW_DESIGN_TICKET_REQUEST,
    getWorkflowDesignTicketSaga
  );
  yield takeEvery(
    LIST_WORKFLOW_DESIGN_TICKETS_REQUEST,
    listWorkflowDesignTicketsSaga
  );
  yield takeEvery(
    UPDATE_WORKFLOW_DESIGN_TICKET_REQUEST,
    updateWorkflowDesignTicketSaga
  );
  yield takeEvery(
    DELETE_WORKFLOW_DESIGN_TICKET_REQUEST,
    deleteWorkflowDesignTicketSaga
  );
  yield takeEvery(
    CHECK_WORKFLOW_DESIGN_STATUS_REQUEST,
    checkWorkflowDesignStatusSaga
  );
}

export default workflowDesignSubmissionSaga;
